import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import UnitConfigurationHeaders from "./UnitConfigurationHeaders";
import Units from "./Units/Units";


const UnitConfiguration = () =>{
  
    const chipHeaders = [""];
    const chipItems: React.ReactNode[] = [
      <Units/>,
      
      
    ];
  
    return (
      <div className="page-content">
        <UnitConfigurationHeaders />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default UnitConfiguration